import { createReducer } from '@ngrx/store';

// import * as ACTIONS from './campaign-context-actions';
import { initialState } from './account-state';

// import { produceOn } from 'app/_state/produce-on';

const _accountReducers = createReducer(initialState,
  // Set the current campaign
  // produceOn(ACTIONS.SET_CURRENT_CAMPAIGN, (state, props) => {
  //     state.current_campaign = props.payload;
  // })
);

export function accountReducers(state, action) {
  return _accountReducers(state, action);
}
